import md5 from "md5";
import { SecurityUtils } from "revlock-webutils";
import { getPlan } from "./auth";
import { setData2 } from "../redux/actions/data.actions";
import { Auth } from "aws-amplify";
import store from '../redux/ReduxStore'

export const openChat = () => {
    let crisp = window.$crisp;
    if (!crisp)
        return;

    crisp.push(["do", "chat:open"])
}


//setup the crisp system
window.CRISP_READY_TRIGGER = function () {
    if (window.CRISP_TOKEN_ID) {
        window.$crisp.push(["set", "user:email", [window.CRISP_email]]);
        setData2("crispReady", "true");
    }
}

export const initializeCrispSession = (user, isDemoUser) => {
    if (!window.CRISP_TOKEN_ID || window.CRISP_TOKEN_ID != user.username) {
        window.$crisp = [];
        if (!isDemoUser) {
            window.CRISP_TOKEN_ID = user.username;
            window.CRISP_email = user.attributes.email;
        }
        window.CRISP_WEBSITE_ID = "f3bba161-1a40-425c-8966-586d5aab0f1c";

        window.CRISP_RUNTIME_CONFIG = {
            session_merge: true
        };

        (function () {
            const d = document;
            const s = d.createElement("script");
            s.src = "https://client.crisp.chat/l.js";
            s.async = 1;
            d.getElementsByTagName("head")[0].appendChild(s);
        })();
    }
}

export const initializeCrisp = (user, currentOrganization) => {
    let crisp = window.$crisp;
    if (!crisp)
        return;

    const email = crisp.get("user:email");
    if (!email) {
        crisp.push(["set", "user:email", [user.attributes.email]]);
        const avatarId = md5(user.id && user.id.toLowerCase() || "default")
        crisp.push(["set", "user:avatar", [`https://www.gravatar.com/avatar/${avatarId}?d=robohash`]])
        if (user.attributes.phone_number)
            crisp.push(["set", "user:phone", [user.attributes.phone_number]]);

        if (currentOrganization) {
            crisp.push(["set", "user:company", [currentOrganization.name, {
                url: `http://${currentOrganization.domain}`,
            }]]);

            crisp.push(["set", "session:data", ["base_org_id", currentOrganization.id.substring(1)]]);
            const roles = SecurityUtils.getRoles(currentOrganization.id, user);
            crisp.push(["set", "session:data", ["current_roles", JSON.stringify(roles)]]);
        }

        if (currentOrganization.partner)
            crisp.push(["set", "session:data", ["partner", currentOrganization.partner]]);
        const plan = getPlan();
        if (plan) {
            crisp.push(["set", "session:data", ["current_plan", plan.name]]);
            crisp.push(["set", "session:data", ["current_plan_added_on", plan.addedOn]]);
            if (plan.trial)
                crisp.push(["set", "session:data", ["is_trial", "true"]]);
        }
    }

}

const readUserData = async () => {
    try {
        const authUser = await Auth.currentAuthenticatedUser({ bypassCache: true })

        const rawData = authUser.attributes['custom:data'];
        if (rawData && rawData.length > 0) {
            const data = JSON.parse(rawData);
            return { data, authUser };
        }

        return { data: null };

    } catch (e) {
        console.warn("Failed to read user data ", e);
        return { data: null };
    }
}

export const markSeenTour = async (orgId, tour = 'welcome_tour', history) => {
    let { data } = await readUserData();

    if (!data) {
        data = { tours: [] }
    }

    if (!data.tours) {
        data.tours = [];
    }

    data.tours.push(tour);

    try {
        const authUser = await Auth.currentAuthenticatedUser();

        if (authUser) {
            if (authUser.attributes['custom:data'] == undefined) {
                await Auth.updateUserAttributes(authUser, { 'custom:data': JSON.stringify(data) });
                store.dispatch({
                    type: 'SET_TOUR'
                })
            }

            if (getPlan().name == 'rev-essential') {
                // Redirect to the QuickView page.
                history.push(`/${orgId}/reports/quickview/revenue`)
            }
        } else {
            console.warn("Unable to find authUser to mark tour state");
        }
    } catch (e) {
        console.warn("Failed to update attributes due to", e);
    }
}

export const hasSeenTour = (tour = 'welcome_tour', currentUser) => {
    const { data } = currentUser;
    return data && data.tours.find((n) => n == tour) || false;
}
